import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

export default function SubmitButton({ onTap }) {
  useEffect(
    () => $('#wrapper').off('tap.submitButton', '#submit-btn:not(.disabled)'),
    [],
  );

  const tapCallback = useCallback(
    (e) => {
      e.preventDefault();
      // if not disabled
      onTap();
    },
    [onTap],
  );
  return (
    <div className="submit-btn-container text-center">
      <button
        type="button"
        className="btn btn-w-icon"
        id="submit-btn"
        data-btn="submit-btn"
        onClick={tapCallback}
      >
        <span className="icon-check"></span>
      </button>
    </div>
  );
}

SubmitButton.propTypes = {
  onTap: PropTypes.func,
};
